import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  styled,
  Avatar,
  Chip,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
// import { useFetchEmployeeProfileMutation } from "../../services/profileService";
import useAuth from "../../hooks/useAuth";
import HistoryIcon from "@mui/icons-material/History";
import DescriptionIcon from "@mui/icons-material/Description";
import { useFetchReportHistoryQuery } from "../../services/user-reportService";
import CloseIcon from "@mui/icons-material/Close";
import { DataGrid } from "@mui/x-data-grid";
function History() {
  const { users } = useAuth();

  const navigate = useNavigate();

  const employeeId = users?.user_id;

  //   const [anchorProfile, setAnchorProfile] = useState(null);
  //   const [anchorNotification, setAnchorNotification] = useState(null);
  // const [open, setOpen] = useState(false);

  // const [fetchEmployeeProfile] = useFetchEmployeeProfileMutation();
  // const [reportHistory, setReportHistory] = useState([]);
  // const [emailHistory, setEmailHistory] = useState([]);

  const [openHistory, setOpenHistory] = useState(false);
  const [openEmailHistory, setOpenEmailHistory] = useState(false);

  const {
    data: reportReportHistories,

    refetch: reportHisotory,
  } = useFetchReportHistoryQuery(employeeId);
  //   console.log("reportReportHistories", reportReportHistories);

  const handleCloseHistory = () => {
    setOpenHistory(false);
  };

  const handleCloseEmailHistory = () => {
    setOpenEmailHistory(false);
  };

  const reportReportHistoriesArray = Array.isArray(
    reportReportHistories?.data?.report_history
  )
    ? reportReportHistories?.data?.report_history
    : [];

  const emailHistoryArray = Array.isArray(
    reportReportHistories?.data?.email_history
  )
    ? reportReportHistories?.data.email_history
    : [];

  const handleHistoryClick = () => {
    setOpenHistory(true);

    reportHisotory();

    // Fetch data when opening
  };

  const handleEmailHistoryClick = () => {
    setOpenEmailHistory(true);
    // setOpen(true);

    // reportHisotory()
    reportHisotory();

    // Fetch data when opening
  };

  const columnsReport = [
    {
      field: "version_number",
      headerName: "Version Number",
      width: 200,
    },
    {
      field: "body",
      headerName: "Content",
      flex: 1,
      minWidth: 300,
      renderCell: (params) => {
        const content = params.row.content;
        if (!content || Object.keys(content).length === 0) {
          return <Typography variant="body2">No content available</Typography>;
        }
        return (
          <>
            <table width="100%" className="data-table-wrap">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Title</th>
                  <th>Job Summary</th>
                  <th>Area</th>
                  <th>Importance</th>
                  <th>Time Spent</th>
                  <th>Activity Area</th>
                  <th>Activity Time Spent</th>
                </tr>
              </thead>
              <tbody>
                {content?.core_focus_areas?.map((area, idx) => (
                  <React.Fragment key={idx}>
                    {area.critical_activities?.map((activity, activityIdx) => (
                      <tr key={activityIdx}>
                        {activityIdx === 0 && (
                          <>
                            {idx === 0 && (
                              <>
                                <td
                                  rowSpan={content.core_focus_areas.reduce(
                                    (sum, area) =>
                                      sum +
                                      (area.critical_activities?.length || 1),
                                    0
                                  )}
                                >
                                  {content?.role_review?.name || "N/A"}
                                </td>
                                <td
                                  rowSpan={content.core_focus_areas.reduce(
                                    (sum, area) =>
                                      sum +
                                      (area.critical_activities?.length || 1),
                                    0
                                  )}
                                >
                                  {content?.role_review?.title || "N/A"}
                                </td>
                                <td
                                  rowSpan={content.core_focus_areas.reduce(
                                    (sum, area) =>
                                      sum +
                                      (area.critical_activities?.length || 1),
                                    0
                                  )}
                                >
                                  {content?.role_review?.job_summary || "N/A"}
                                </td>
                              </>
                            )}
                            <td rowSpan={area.critical_activities.length}>
                              {area.area || "N/A"}
                            </td>
                            <td rowSpan={area.critical_activities.length}>
                              {(area.importance !== null &&
                              area.importance !== undefined
                                ? area.importance
                                : "N/A") + "%"}
                            </td>
                            <td rowSpan={area.critical_activities.length}>
                              {(area.time_spent !== null &&
                              area.time_spent !== undefined
                                ? area.time_spent
                                : "N/A") + "%"}
                            </td>
                          </>
                        )}
                        <td>{activity.area || "N/A"}</td>
                        <td>
                          {(activity.importance !== null &&
                          activity.importance !== undefined
                            ? activity.importance
                            : "N/A") + "%"}
                        </td>
                      </tr>
                    ))}
                    {(!area.critical_activities ||
                      area.critical_activities.length === 0) && (
                      <tr>
                        {idx === 0 && (
                          <>
                            <td rowSpan={content.core_focus_areas.length}>
                              {content?.role_review?.name || "N/A"}
                            </td>
                            <td rowSpan={content.core_focus_areas.length}>
                              {content?.role_review?.title || "N/A"}
                            </td>
                            <td rowSpan={content.core_focus_areas.length}>
                              {content?.role_review?.job_summary || "N/A"}
                            </td>
                          </>
                        )}
                        <td>{area.area || "N/A"}</td>
                        <td>
                          {(area.importance !== null &&
                          area.importance !== undefined
                            ? area.importance
                            : "N/A") + "%"}
                        </td>
                        <td>
                          {(area.time_spent !== null &&
                          area.time_spent !== undefined
                            ? area.time_spent
                            : "N/A") + "%"}
                        </td>
                        <td>N/A</td>
                        <td>N/A</td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </>
        );
      },
    },
  ];
  const columnsEmail = [
    {
      field: "subject",
      headerName: "Subject",
      width: 180,
    },
    {
      field: "body",
      headerName: "Body",
      flex: 2,
      minWidth: 350,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.5,
      minWidth: 100,
      renderCell: (params) => {
        let chipColor;
        if (params.value === "failed") {
          chipColor = "error";
        } else if (params.value === "pending") {
          chipColor = "warning";
        } else if (params.value === "sent") {
          chipColor = "success";
        }
        return <Chip label={params.value} color={chipColor} size="small" />;
      },
    },
    {
      field: "sent_at",
      headerName: "Sent At",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        const date = new Date(params.row.sent_at);

        // Options for toLocaleDateString to format as MM/DD/YYYY
        const options = {
          year: "2-digit", // Use 'numeric' for 4-digit year. '2-digit' for 2-digit
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        };

        return date.toLocaleDateString("en-US", options); // Format the date
      },
    },
  ];

  const emailHistoryWithId = emailHistoryArray.map((item, index) => ({
    ...item,
    id: item.emailId || index,
  }));

  const reportHistoryWithId = reportReportHistoriesArray.map((item, index) => ({
    ...item,
    id: item.emailId || index,
  }));
  return (
    <>
      <SectionWrap component="section">
        <ContainerWrap>
          <RowWrap>
            {/* Reports */}
            <Col6Wrap>
              <DashboardBoxWrap>
                <Avatar
                  sx={{
                    bgcolor: "#F28021",
                    margin: "0 auto 20px",
                    width: "60px",
                    height: "60px",
                  }}
                >
                  <DescriptionIcon sx={{ fontSize: "40px" }} />
                </Avatar>
                <TitleWrap>Reports</TitleWrap>
                <ContentWrap>
                  View reports generated by you. Click the button to access your
                  reports.
                </ContentWrap>
                <CustomBtn
                  type="submit"
                  variant="outlined"
                  onClick={() => navigate("/user-reports")}
                >
                  View Reports
                </CustomBtn>
              </DashboardBoxWrap>
            </Col6Wrap>

            {/* History Logs */}
            <Col6Wrap>
              <DashboardBoxWrap>
                <Avatar
                  sx={{
                    bgcolor: "#F28021",
                    margin: "0 auto 20px",
                    width: "60px",
                    height: "60px",
                  }}
                >
                  <HistoryIcon sx={{ fontSize: "40px" }} />
                </Avatar>
                <TitleWrap>History Logs</TitleWrap>
                <ContentWrap>
                  View History logs generated by you. Click the button to access
                  your history.
                </ContentWrap>
                <Box
                  sx={{
                    display: "flex",
                    columnGap: "10px",
                    justifyContent: "center",
                  }}
                >
                  <CustomBtn
                    variant="outlined"
                    onClick={handleHistoryClick}
                    aria-controls={openHistory ? "history-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={openHistory ? "true" : undefined}
                  >
                    Report Versions
                  </CustomBtn>
                  <CustomBtn
                    variant="outlined"
                    onClick={handleEmailHistoryClick}
                    aria-controls={
                      openEmailHistory ? "history-menu" : undefined
                    }
                    aria-haspopup="true"
                    aria-expanded={openEmailHistory ? "true" : undefined}
                  >
                    Email History
                  </CustomBtn>
                </Box>
                {/* Report Versions */}
                <Dialog
                  open={openHistory}
                  onClose={handleCloseHistory}
                  fullWidth
                  maxWidth="lg"
                  sx={{
                    "& .MuiDialog-paper": {
                      padding: "30px",
                    },
                  }}
                >
                  <IconButton
                    aria-label="close"
                    //   onClick={handleClose}
                    onClick={handleCloseHistory}
                    sx={(theme) => ({
                      position: "absolute",
                      right: 8,
                      top: 8,
                      color: theme.palette.grey[500],
                    })}
                  >
                    <CloseIcon />
                  </IconButton>
                  <DialogTitleWrap>Report Versions</DialogTitleWrap>
                  <DataGrid
                    sx={{ "& .MuiDataGrid-cell": { padding: "20px 10px" } }}
                    rows={reportHistoryWithId}
                    columns={columnsReport}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 1,
                        },
                      },
                    }}
                    pageSizeOptions={[1]}
                    disableRowSelectionOnClick
                    disableColumnMenu={true}
                    getRowHeight={() => "auto"}
                  />
                </Dialog>
                {/* Email History */}
                <Dialog
                  open={openEmailHistory}
                  onClose={handleCloseEmailHistory}
                  fullWidth
                  maxWidth="lg"
                  sx={{
                    "& .MuiDialog-paper": {
                      padding: "30px",
                    },
                  }}
                >
                  <IconButton
                    aria-label="close"
                    //   onClick={handleClose}
                    onClick={handleCloseEmailHistory}
                    sx={(theme) => ({
                      position: "absolute",
                      right: 8,
                      top: 8,
                      color: theme.palette.grey[500],
                    })}
                  >
                    <CloseIcon />
                  </IconButton>
                  <DialogTitleWrap>Email History</DialogTitleWrap>
                  <DataGrid
                    rows={emailHistoryWithId}
                    columns={columnsEmail}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 30,
                        },
                      },
                    }}
                    pageSizeOptions={[30]}
                    disableRowSelectionOnClick
                    disableColumnMenu={true}
                  />
                </Dialog>
              </DashboardBoxWrap>
            </Col6Wrap>
          </RowWrap>
        </ContainerWrap>
      </SectionWrap>
    </>
  );
}

export default History;
const SectionWrap = styled(Box)(() => ({
  padding: "50px 0",
}));
const ContainerWrap = styled(Box)(() => ({
  width: "100%",
  maxWidth: "1170px",
  paddingLeft: "15px",
  paddingRight: "15px",
  marginLeft: "auto",
  marginRight: "auto",
}));
const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col6Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "50%",
  paddingLeft: "15px",
  paddingRight: "15px",
  "@media (max-width: 767px)": {
    maxWidth: "100%",
  },
}));
const DashboardBoxWrap = styled(Box)(() => ({
  padding: "50px 50px",
  background: "#ffffff",
  borderRadius: "7px",
  textAlign: "center",
  marginBottom: "30px",
  height: "calc(100% - 30px)",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
  "@media (max-width: 991px)": {
    padding: "30px 30px",
  },
}));
const TitleWrap = styled(Typography)(() => ({
  fontSize: "20px",
  fontWeight: "600",
  lineHeight: "1.445",
  color: "#000000",
  marginBottom: "15px",
}));
const ContentWrap = styled(Typography)(() => ({
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "1.445",
  color: "#7C7C7C",
  marginBottom: "25px",
}));
const CustomBtn = styled(Button)(() => ({
  width: "100%",
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "10px",
  padding: "13px 10px",
  maxWidth: "200px",
  boxShadow: "none !important",
}));
const DialogTitleWrap = styled(DialogTitle)(() => ({
  fontSize: "20px",
  fontWeight: "600",
  lineHeight: "1.445",
  color: "#000000",
  marginBottom: "15px",
  padding: "0",
}));
